import axios from './../api.js'

function getVersionsFromSorting (versions, period) {
  let tempArray = []

  function insertDateToArray (key, date) {
    let foundObject = tempArray.find(dateObject => dateObject.key === key)
    if (foundObject) {
      foundObject.dates.push(date)
    } else {
      tempArray.push({ key: key, dates: [date] })
    }
  }

  function getDateKey (date) {
    let year = date.getFullYear()
    let month = date.getMonth()

    switch (period) {
      case 'all':
        return date.getTime().toString()
      case 'month':
        return year + 'M' + month
      case 'quarter':
        return year + 'Q' + Math.floor(month / 3)
      case 'half':
        return year + 'H' + Math.floor(month / 6)
      case 'year':
        return year
    }
  }

  versions.forEach(version => {
    let date = new Date(version.date)

    if (period !== 'none') {
      insertDateToArray(getDateKey(date), date)
    }
  })

  let dateArray = tempArray.map(dateObj => dateObj.dates[dateObj.dates.length - 1])

  return versions.map(version => {
    version.selected = dateArray.some(date => new Date(version.date).getTime() === date.getTime())
    return version
  })
}

const state = {
  projectVersions: []
}

const getters = {
  getProjectVersions: state => {
    return state.projectVersions
  },
  getHistoryPhaseGoals: (state, getters, rootState) => (wheel, phaseIndex, onlySelected) => {
    let selectedPhase = wheel.contentJson.phases.find(phase => phase.code === rootState.global.profile.phases[phaseIndex].code)
    if (selectedPhase) {
      return selectedPhase.goals.sort((a, b) => a.code - b.code)
    }
    return false
  }
}

const mutations = {
  setProjectVersions: (state, payload) => {
    if (Array.isArray(payload)) {
      payload.forEach(version => {
        version.selected = true
      })

      state.projectVersions = payload
    } else {
      // sorting
      let versions = payload.versions
      let sorting = payload.sorting
      state.projectVersions = getVersionsFromSorting(versions, sorting)
    }
  }
}

const actions = {
  async setProjectVersions ({ commit, rootState }, sorting) {
    if (rootState.global.project.projectId) {
      if (!sorting) {
        try {
          const response = await axios.get('/Public/GetProjectVersionList?ProjectId=' + rootState.global.project.projectId)
          if (response) {
            commit('setProjectVersions', response.data)
          }
        } catch (err) {
          throw err
        }
      } else {
        commit('setProjectVersions', { versions: state.projectVersions, sorting: sorting })
      }
    }
  },
  clearVersions: ({ commit }) => {
    state.projectVersions = []
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
